export default function DirectoryFilters({ filters, values, onChange, onReset }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {filters.map((filter) => (
        <label key={filter.key} className="grid gap-2 text-sm font-black text-neutral-950">
          {filter.label}
          <select
            aria-label={filter.label}
            value={values[filter.key] || ""}
            onChange={(event) => onChange(filter.key, event.target.value)}
            className="focus-ring min-h-11 rounded-xl border border-neutral-300 bg-white px-3 py-2 text-sm font-semibold text-neutral-800"
          >
            <option value="">All {filter.label.toLowerCase()}</option>
            {filter.options.map((option) => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        </label>
      ))}
      <div className="flex items-end">
        <button type="button" onClick={onReset} className="btn-secondary w-full">Reset filters</button>
      </div>
    </div>
  );
}
